var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"font-weight-light primary--text"},[_vm._v(_vm._s(_vm.forecast.main))])])
}
var staticRenderFns = []

export { render, staticRenderFns }